import React from 'react';
import { useIntl } from 'react-intl';
import IntlMessage from '../helpers/intlMessage';

export function getDate(periodo) {
    let dtinicial = new Date();
    let dtfinal = new Date();
  
    switch (periodo) {
      case 'hoje':
        dtinicial = new Date();
        dtfinal = new Date();
        break;
      case 'ontem':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 1));
        dtfinal = new Date();
        break;
      case 'anteontem':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 2));
        dtfinal = new Date();
        break;
      case 'semana':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 7));
        dtfinal = new Date();
        break;
      case 'quinzena':
        dtinicial = new Date(dtfinal.setDate(dtfinal.getDate() - 15));
        dtfinal = new Date();
        break;
      case 'mes':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 1));
        dtfinal = new Date();
        break;
      case 'doisMeses':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 2));
        dtfinal = new Date();
        break;
      case 'tresMeses':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 3));
        dtfinal = new Date();
        break;
      case 'seisMeses':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 6));
        dtfinal = new Date();
        break;
      case 'ano':
        dtinicial = new Date(dtfinal.setMonth(dtfinal.getMonth() - 12));
        dtfinal = new Date();
        break;
      default:
        dtinicial = new Date();
        dtfinal = new Date();
    }
  
    const payload = {
      dtinicial,
      dtfinal,
    };
  
    return payload;
}
export function mapGenero(genero) {
  switch (genero) {
    case 'M':
      return <IntlMessage id = "dashboards.examDetails.masculine"/>;
      break;
    case 'F':
      return <IntlMessage id = "dashboards.examDetails.feminine"/>;
      break;

    default:
      return <IntlMessage id = "dashboards.examDetails.undefined"/>;
  }
}

export function dataEng(e) {
  const data = e.split('/');
  const dia = data[0];
  const mes = data[1];
  const ano = data[2];
  return new Date(ano + '-' + mes + '-' + dia + 'T00:00');
}

export function calcIdade(
  nasc,
  textAnos,
  textMeses
) {

  const intl = useIntl();
  textAnos = intl.formatMessage({id: 'dashboards.examDetails.years'})
  textMeses = intl.formatMessage({id: 'dashboards.examDetails.months'})

  let data = nasc;
  let text = '';
  const isDataPt = nasc.indexOf('/') > -1;
  if (isDataPt) {
    data = dataEng(nasc);
  }
  const aniv =
    new Date().getMonth() >= new Date(data).getMonth();
  let anos =
    new Date().getFullYear() - new Date(data).getFullYear() - 1;
  let meses = new Date().getMonth() - new Date(data).getMonth() +1;

  if (new Date().getMonth() - new Date(data).getMonth() < 0) {
    meses =
      new Date().getMonth() +
      1 +
      (11 - new Date(data).getMonth());
  }
  aniv && anos++;
  text = `(${anos}) ${textAnos} (${meses}) ${textMeses}`;
  return textAnos && textMeses ? text : anos;
}


// WEBPACK FOOTER //
// ./src/functions/general.js